module.exports = __webpack_public_path__ + "img/GPS55-note.2f681cb1.png";